module.exports = __webpack_public_path__ + "img/xp2.5a215271.png";